import { gql } from '@apollo/client';

export const visitDurationName = 'VisitDuration';
export const visitDuration = gql`
	fragment ${visitDurationName} on Member {
		HRT_E: defaultVisitDuration(serviceType: HRT_E)
		HRT_T: defaultVisitDuration(serviceType: HRT_T)
		VC: defaultVisitDuration(serviceType: VC)
		ADHD: defaultVisitDuration(serviceType: VC, clinicalTopic: ADHD)
		MHT: defaultVisitDuration(serviceType: MHT)
		MHM: defaultVisitDuration(serviceType: MHM)
	}
`;
